module.exports = __webpack_public_path__ + "static/media/2bohommes_modalités_pratiques.58d0efa7.svg";